import { Spinner } from "react-bootstrap";
import FlexBox from "./flex-box";
import { FC } from "react";

interface LoadingBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  animation?: "border" | "grow";
  message?: string;
  color?: string;
  isNoFlex?: boolean;
}

const LoadingBox: FC<LoadingBoxProps> = ({
  animation = "border",
  color = "primary",
  isNoFlex = false,
  message,
  ...props
}) => {
  if (isNoFlex) {
    return (
      <>
        <Spinner animation={animation} className={`text-${color}`} />
        {message && <p>{message}</p>}
      </>
    );
  }

  return (
    <FlexBox
      justifyContent="center"
      alignItems="center"
      className="loading-box"
      direction="column"
      {...props}
    >
      <Spinner animation={animation} className={`text-${color}`} />
      {message && <p>{message}</p>}
    </FlexBox>
  );
};

export default LoadingBox;
